<!-- 电子钱包开通页面 --->
<template>
  <div class="open-wallet">
    <div class="top-bg"></div>
    <div class="title">开通电子钱包</div>
    <div class="solgan" v-for="solgan of solgans" :key="solgan.title">
      <div class="img" :style="{ backgroundImage: 'url(' + solgan.iconImg + ')' }"></div>
      <div class="content">
        <div class="sub-title">{{ solgan.title }}</div>
        <div class="details">{{ solgan.details }}</div>
      </div>
    </div>
    <div class="open-btn-wrapper">
      <el-button class="open-btn" type="primary" @click="openEwallet()">立即开通电子钱包</el-button>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
  props: {},
  setup() {
    const loading = inject('$loading');
    const message = inject('$message');
    const solgans = [
      {
        title: '预存费用',
        details: '费用提前存，续费、扩科先人一步',
        iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/pc/img/teacher/0002.png',
      },
      {
        title: '钱包支付',
        details: '结转金额不出学校，钱包余额一键支付',
        iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/pc/img/teacher/0003.png',
      },
      {
        title: '数据统计',
        details: '校区、学员多维度统计，钱包收支清晰明了',
        iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/pc/img/teacher/0004.png',
      },
    ];

    // 开通电子钱包
    const api = inject('api');
    const store = inject('store');
    async function openEwallet() {
      const { close } = loading();
      await api
        .companyWalletOpen()
        .then((res) => {
          if (res.code === 200) {
            store.action('refreshUser');
            message.success('电子钱包开通成功');
          }
          if (res.code > 60000) {
            message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => close());
    }
    return {
      solgans,
      openEwallet,
    };
  },
};
</script>

<style lang="scss" scoped>
.open-wallet {
  padding: 48px;
  background-color: var(--white);
  .top-bg {
    margin: 0 auto;
    width: 175px;
    height: 130px;
    background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/pc/img/teacher/0001.png)
      center/cover no-repeat;
  }
  .title {
    margin: 24px 0 40px 0;
    text-align: center;
    font-size: var(--fs-ex2);
    line-height: var(--lh-ex2);
    font-weight: bold;
  }
  .open-btn-wrapper {
    margin-top: 56px;
    text-align: center;
  }
  .solgan {
    justify-content: center;
    align-items: center;
    display: flex;
    margin: 0 auto 43px auto;
    color: var(--g3);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    .sub-title {
      margin-bottom: 4px;
      color: var(--g1);
      font-size: var(--fs-ex1);
      line-height: var(--lh-ex1);
    }
    .img-wrapper {
      text-align: right;
      width: 60px;
    }
    .content {
      text-align: left;
      width: 280px;
    }
    .img {
      width: 49px;
      height: 49px;
      margin-right: 16px;
      background-size: 49px;
    }
  }
}
</style>
